import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "page account-page" }
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "page-eyebrow" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 0,
  class: "glass-card account-card"
}
const _hoisted_6 = { class: "account-row" }
const _hoisted_7 = { class: "account-label" }
const _hoisted_8 = { class: "account-value" }
const _hoisted_9 = { class: "account-row" }
const _hoisted_10 = { class: "account-label" }
const _hoisted_11 = { class: "account-value" }
const _hoisted_12 = {
  key: 0,
  class: "account-row"
}
const _hoisted_13 = { class: "account-label" }
const _hoisted_14 = { class: "account-value" }
const _hoisted_15 = {
  key: 1,
  class: "glass-card account-card"
}
const _hoisted_16 = { class: "account-note" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Logo = _resolveComponent("Logo")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Logo),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.jsonData.accountEyebrow), 1),
        _createElementVNode("h1", {
          innerHTML: _ctx.jsonData.accountTitle
        }, null, 8, _hoisted_4),
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "page-divider" }, null, -1))
      ]),
      (_ctx.currentUser)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.jsonData.authFullName), 1),
              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.currentUser.fullName), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.jsonData.authEmail), 1),
              _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.currentUser.email), 1)
            ]),
            (_ctx.currentUser.phone)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.jsonData.authPhone), 1),
                  _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.currentUser.phone), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              class: "account-logout",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
            }, _toDisplayString(_ctx.jsonData.accountLogout), 1)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.jsonData.accountLoggedOut), 1),
            (_ctx.showRegisterButton)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "account-cta",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openAuth && _ctx.openAuth(...args)))
                }, _toDisplayString(_ctx.jsonData.authRegisterTab) + " / " + _toDisplayString(_ctx.jsonData.authLoginTab), 1))
              : _createCommentVNode("", true)
          ]))
    ])
  ], 64))
}